<template>
<div style="height: 100%;width: 100%;padding: 20px;box-sizing: border-box;background: #FFFFFF">
  <div style="height: 50px">
    <el-date-picker v-fixZoom v-model="orderDate" type="daterange" unlink-panels
      range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
      :picker-options="pickerOptions" value-format="yyyy-MM-dd" style="margin-right: 10px; width: 400px">
    </el-date-picker>
    <el-button type="primary" @click="searchOrderData()">查询</el-button>
  </div>
  <div style="height: calc(100% - 100px)">
    <el-table :data="tableData" border style="width: 100%" highlight-current-row ref="singleTable">
      <el-table-column
        type="index"
        label="序号"
        width="70"
        align="center">
      </el-table-column>
      <el-table-column
        label="发起类型"
        width="80"
        align="center">
        <template slot-scope="scope">
          <button v-if="scope.row.service_from === 1 || scope.row.service_from === 0" class="blue-tab">客服</button>
          <button v-if="scope.row.service_from === 2" class="purple-tab">循环单</button>
          <button v-if="scope.row.service_from === 3" class="yellow-tab">家人</button>
          <button v-if="scope.row.service_from === 4" class="pink-tab">老人</button>
        </template>
      </el-table-column>
      <el-table-column
        label="服务对象"
        min-width="110"
        align="center">
        <template slot-scope="scope">
          <span>{{scope.row.person_name}}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="服务内容"
        min-width="110"
        align="center">
        <template slot-scope="scope">
          <span>{{scope.row.supplier_type_name }}</span>
        </template>
      </el-table-column>
<!--      <el-table-column-->
<!--        label="服务频率"-->
<!--        min-width="100"-->
<!--        align="center">-->
<!--        <template slot-scope="scope">-->
<!--          <span v-if="scope.row.is_cycle === 1">单次</span>-->
<!--          <span v-if="scope.row.is_cycle === 2">循环 </span>-->
<!--          <span>{{getFrequencyName(scope.row)}}</span>-->
<!--        </template>-->
<!--      </el-table-column>-->
      <el-table-column
        label="服务提供商"
        min-width="100"
        align="left">
        <template slot-scope="scope">
          <el-tag size="mini" v-if="scope.row.supplier_org_id !== 0" type="success">指派</el-tag>
          <el-tag size="mini" v-else type="warning">抢单</el-tag>
          <span>{{scope.row.supplier_name}}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="服务人员"
        min-width="100"
        align="left">
        <template slot-scope="scope">
          <el-tag size="mini" v-if="scope.row.supplier_person_id !== 0" type="success">指派</el-tag>
          <el-tag size="mini" v-else type="warning">抢单</el-tag>
          <span>{{scope.row.supplier_person_name}}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="begin_time"
        label="开始时间"
        min-width="110"
        align="center">
      </el-table-column>
      <el-table-column
        prop="end_time"
        label="结束时间"
        min-width="110"
        align="center">
      </el-table-column>
      <el-table-column align="center" label="操作" width="240">
        <template slot-scope="scope">
          <el-button size="small" type="warning" @click="handleChangeNew(scope.row)">现在处理</el-button>
        </template>
      </el-table-column>
    </el-table>

  </div>
  <div style="height: 40px;text-align: center">
    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
      :current-page="currentPage" :page-sizes="[10, 20, 50, 100]" :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper" :total="totalCells">
    </el-pagination>
  </div>
  <el-dialog title="处理服务单" :visible.sync="handleOrderShow" v-if="handleOrderShow"
    width="600px" :show-close="true" :close-on-click-modal="false" center>
    <order-handle :handleOrderRow="handleRow" v-model="handleOrderShow"></order-handle>
  </el-dialog>
  <!-- 处理服务单 -->
  <el-dialog width="800px" :visible.sync="recordShow" v-if="recordShow" center append-to-body class="all-open">
    <div class="title-top-alarm">
      <div><span>处理服务单</span></div>
      <div class="line-title"></div>
    </div>
    <order-handle-open :soOptions="soOptions" :orderObj="orderObj" v-model="recordShow" @closeOrder="closeOrder"></order-handle-open>
  </el-dialog>
</div>
</template>

<script>
import {querysupplierservicerecords} from '../../api/companyorder'
import {queryfrequency} from '../../api/serviceObject'
import {sendSub} from '../../mq'
import orderHandle from '../handlealarm/childComponents/orderHandle.vue'
import orderHandleOpen from '../datamanagement/childComponents/orderHandleOpen.vue'
export default {
  name: 'supplierOrder',
  components: {orderHandle, orderHandleOpen},
  data () {
    return {
      orderDate: [],
      pickerOptions: {
        // disabledDate (time) {
        //   return time.getTime() > Date.now()
        // },
        // shortcuts: []
      },
      pss: [],
      tableData: [],
      pageSize: 10,
      currentPage: 1,
      totalCells: 0,
      frequencys: [],
      handleOrderShow: false,
      handleRow: {
        row: {}
      },
      soOptions: [], // 服务商
      recordShow: false,
      orderObj: {
        row: '',
        types: []
      }
    }
  },
  created () {
    this.golobleObject.getDoneOder = this.getEndDataShow
    this.golobleObject.updateTableOrder = this.getOrderTableData
    this.getFrequency()
  },
  methods: {
    // 查询频率
    getFrequency () {
      let data = {
        orgid: this.$store.state.user.orgid
      }
      queryfrequency(data).then(res => {
        this.frequencys = res.data.frequencys
        this.getOrderTableData()
      }).catch(() => {})
    },
    searchOrderData () {
      this.currentPage = 1
      this.getOrderTableData()
    },
    getOrderTableData () {
      let params = {
        size: this.pageSize,
        page: this.currentPage
      }
      let data = {
        start_time: this.orderDate[0] ? this.orderDate[0] + ' 00:00:00' : '',
        end_time: this.orderDate[1] ? this.orderDate[1] + ' 23:59:59' : ''
      }
      querysupplierservicerecords(params, data).then(res => {
        this.pss = res.data.pss
        this.totalCells = res.data.cnt
        this.getEndDataShow()
      }).catch(() => {})
    },
    getEndDataShow () {
      let arr = this.pss
      let handleIDList = []
      const handle = this.store2.state.company.companyHandle
      // console.log(999, handle)
      for (let i = 0; i < handle.length; i++) {
        let obj1 = handle[i]
        handleIDList.push(parseInt(obj1.id))
      }
      let endArr = []
      for (let i = 0; i < arr.length; i++) {
        const alarmObj = arr[i]
        alarmObj.handleuesrname = '未处理'
        if (handleIDList.indexOf(alarmObj.id) > -1) {
          for (let ii = 0; ii < handle.length; ii++) {
            const usernameObj = handle[ii]
            if (usernameObj.id === alarmObj.id) {
              alarmObj.buttondisable = true
              alarmObj.handleuesrname = usernameObj.name + '正在处理'
            } else {
              alarmObj.buttondisable = false
            }
          }
        }
        endArr.push(alarmObj)
      }
      this.tableData = endArr
    },
    getSex (sex) {
      return this.util.getSex(sex + '')
    },
    getAgeDesc (birthday) {
      let result = '--'
      let age = this.util.getAgeByBirth(birthday)
      if (age === '') {
        result = '--'
      } else {
        result = age + '岁'
      }
      return result
    },
    getFrequencyName (row) {
      let frequency = ''
      for (let i = 0; i < this.frequencys.length; i++) {
        if (row.frequency_id === this.frequencys[i].id) {
          frequency = this.frequencys[i].frequency
        }
      }
      return frequency
    },
    // 页码
    handleSizeChange (val) {
      this.pageSize = val
    },
    handleCurrentChange (val) {
      this.currentPage = val
    },
    handleChangeNew (row) {
      row.servicerequirements = [[], []]
      row.pictureArr = []
      if (row !== '') {
        try {
          row.servicerequirements = JSON.parse(row.service_requirements)
          row.pictureArr = JSON.parse(row.picture_requirements)
        } catch (error) {}
      }
      this.orderObj.row = row
      this.recordShow = true
    },
    handleChangeNew1 (row) {
      // console.log(row)
      let mqtts = this.$store.state.user.mqtts
      let name = this.$store.state.user.personname
      let dohandle = {id: row.id, name: name}
      // console.log(dohandle)
      sendSub('/handleorder' + mqtts[0], JSON.stringify(dohandle))
      // this.store2.dispatch('company/update_company_handle', dohandle).then(() => {
      //   this.getShowTable()
      // })
      this.handleRow.row = row
      this.handleOrderShow = true
    },
    closeOrder () {
      this.getOrderTableData()
    }
  }
}
</script>

<style scoped>
.blue-tab{
  padding: 0 8px;
  height: 27px;
  line-height: 27px;
  color: #FFFFFF;
  font-size: 16px;
  background: #5A9CF8;
  border-radius: 3px 3px 3px 3px;
  border: none;
}
.purple-tab{
  padding: 0 8px;
  height: 27px;
  line-height: 27px;
  color: #FFFFFF;
  font-size: 16px;
  background: #A45AF8;
  border-radius: 3px 3px 3px 3px;
  border: none;
}
.yellow-tab{
  padding: 0 8px;
  height: 27px;
  line-height: 27px;
  color: #FFFFFF;
  font-size: 16px;
  background: #F89C5A;
  border-radius: 3px 3px 3px 3px;
  border: none;
}
.pink-tab{
  padding: 0 8px;
  height: 27px;
  line-height: 27px;
  color: #FFFFFF;
  font-size: 16px;
  background: #F85A91;
  border-radius: 3px 3px 3px 3px;
  border: none;
}
</style>



// WEBPACK FOOTER //
// src/components/serviceorder/supplierOrder.vue